document.addEventListener('DOMContentLoaded', function () {
  // Pause announcement marquee on hover
  document.querySelectorAll('.dg-announcement-bar').forEach(function (bar) {
    var track = bar.querySelector('.dg-announcement-bar__track');
    if (!track) return;
    bar.addEventListener('mouseenter', function () { track.style.animationPlayState = 'paused'; });
    bar.addEventListener('mouseleave', function () { track.style.animationPlayState = 'running'; });
  });

  // Shop by Concern arrow navigation
  document.querySelectorAll('[data-dg-concern-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-dg-concern-track]');
    var prev = slider.querySelector('.dg-concern-slider__arrow--prev');
    var next = slider.querySelector('.dg-concern-slider__arrow--next');
    if (!track) return;
    var scrollAmount = function () {
      var card = track.querySelector('.dg-concern-card');
      return card ? card.getBoundingClientRect().width + 20 : 300;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });
});
